var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"type":"warning"},on:{"click":_vm.printHtml}},[_vm._v(" 更多"),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_c('printer-select-modal',{ref:"printer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }